<template>
    <div class="flex mt-[42px] mb-[27px] justify-between h-[42px]">
        <h1
            class="text-[21px] font-medium leading-normal tracking-small text-gray-800"
        >
            {{ $t("vue.account_settings") }}
        </h1>
    </div>

    <SettingsTabs class="mt-[24px]" tab-key="team-settings-api-tokens">
        <PersonalApiToken />
    </SettingsTabs>
</template>
<script setup lang="ts"></script>
